import { Static, Object, Optional } from '@sinclair/typebox';

import { AirportPartnerOperatedNetwork, CityMap } from '../../sas-domain/airports';

export const AwardLocationsQueryParams = Object({
  partner: Optional(AirportPartnerOperatedNetwork),
});
export type AwardLocationsQueryParams = Static<typeof AwardLocationsQueryParams>;

export const AwardLocationsResponse = CityMap;
export type AwardLocationsResponse = Static<typeof AwardLocationsResponse>;
